import { useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { QuestionCard } from "../common";

const questionOptions = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

export const Question4 = ({
  updateQuestion,
  jurisdiction,
  answer,
  updateAnswer,
}) => {
  const [selection, setSelection] = useState(answer || "");
  const navigate = useNavigate();

  const handleSelectionChange = (value) => {
    setSelection(value);
    updateAnswer(value);
    sessionStorage.setItem("answer_q4", value);
  };

  const isNextDisabled = selection === "" || !answer;

  const handleNext = () => {
    if (selection === "no") {
      navigate("/cannot-help", { state: { contentKey: "q4_not_nhs_care" } });
    } else {
      updateQuestion(5);
    }
  };

  return (
    <QuestionCard
      question="Is your complaint about care received from the NHS?"
      options={questionOptions}
      required={true}
      selectedValue={selection}
      onChange={handleSelectionChange}
      onPrevious={() =>
        jurisdiction === "nhs" ? updateQuestion(2) : updateQuestion(3)
      }
      onNext={handleNext}
      showPrevious={true}
      nextDisabled={isNextDisabled}
      name="nhs-care"
    />
  );
};

Question4.propTypes = {
  updateQuestion: PropTypes.func,
  jurisdiction: PropTypes.string,
  answer: PropTypes.string,
  updateAnswer: PropTypes.func,
};
